module.exports = __webpack_public_path__ + "img/mail-icon.ec538447.svg";